import palette from '../palette';

export default {
  root: {
    color: palette.icon,
    '&:hover': {
      color: palette.grey[400],
    },
  },
  colorSecondary: {
    color: palette.icon,
    '&$checked': {
      color: palette.secondary.main,
    },
    '&$disabled': {
      color: palette.icon,
    },
  },
};

